import {MarketerDTO} from '../models/marketer.dto';
import {Marketer} from '../models/marketer.model';

// Helper function to validate coordinates
const isValidCoordinate = (value: any): boolean => {
  return value !== undefined &&
         value !== null &&
         !isNaN(value) &&
         typeof value === 'number' &&
         value >= -90 &&
         value <= 90;
};

const isValidLongitude = (value: any): boolean => {
  return value !== undefined &&
         value !== null &&
         !isNaN(value) &&
         typeof value === 'number' &&
         value >= -180 &&
         value <= 180;
};

export const mapMarketerDTOToModel = (dto: MarketerDTO): Marketer => {
  // تحويل التواريخ من string إلى Date
  const lastLocationUpdate = dto.marketer_info?.last_location_update
    ? new Date(dto.marketer_info.last_location_update)
    : dto.last_location_update
    ? new Date(dto.last_location_update)
    : undefined;
  const createdAt = dto.created_at ? new Date(dto.created_at) : undefined;
  const updatedAt = dto.updated_at ? new Date(dto.updated_at) : undefined;

  // تحديد نص الحالة بالعربية
  const statusText = dto.status === 'active' ? 'نشط' : 'غير نشط';

  // تحديد الاسم للعرض
  const displayName = dto.full_name || dto.username;

  // Extract location data from marketer_info (new structure) or fallback to flat fields (legacy)
  const latitude = dto.marketer_info?.latitude || dto.latitude || dto.lat;
  const longitude = dto.marketer_info?.longitude || dto.longitude || dto.lng;
  const territory = dto.marketer_info?.territory || dto.territory;
  const vehicleType = dto.marketer_info?.vehicle_type || dto.vehicle_type;
  const performanceRating = dto.marketer_info?.performance_rating;

  // Validate and sanitize coordinates
  const validLatitude = isValidCoordinate(latitude) ? latitude : undefined;
  const validLongitude = isValidLongitude(longitude) ? longitude : undefined;

  // Log warning for invalid coordinates
  if (latitude !== undefined && !isValidCoordinate(latitude)) {
    // Invalid latitude for marketer
  }
  if (longitude !== undefined && !isValidLongitude(longitude)) {
    // Invalid longitude for marketer
  }

  // Extract role from user_roles array (new structure)
  const role = dto.user_roles?.[0]?.role?.name || 'market_developer';

  const mapped = {
    id: dto.id.toString(),
    username: dto.username,
    fullName: dto.full_name,
    email: dto.email,
    phoneNumber: dto.phone_number,

    // إحداثيات جغرافية (from marketer_info or legacy fields)
    latitude: validLatitude,
    longitude: validLongitude,
    distance: dto.distance,

    // معلومات إضافية للمسوق (from marketer_info)
    territory,
    vehicleType,
    performanceRating,
    lastLocationUpdate,

    // معلومات الحالة والدور
    status: dto.status as 'active' | 'inactive',
    role,
    onlineStatus: dto.online_status,

    // معلومات التوقيت
    createdAt,
    updatedAt,

    // خصائص للخريطة (مُضافة محلياً)
    lat: validLatitude,  // alias لـ latitude للتوافق مع react-map-gl
    lng: validLongitude, // alias لـ longitude للتوافق مع react-map-gl

    // معلومات إضافية للعرض
    displayName,
    statusText,

    // Backward compatibility aliases
    name: dto.full_name,
    phone: dto.phone_number,
    isActive: dto.status === 'active',
    region: territory // alias for territory
  };

  return mapped;
};

export const mapMarketerModelToDTO = (marketer: Marketer): MarketerDTO => ({
  id: typeof marketer.id === 'string' ? parseInt(marketer.id) : marketer.id,
  username: marketer.username,
  full_name: marketer.fullName,
  email: marketer.email,
  phone_number: marketer.phoneNumber,
  lat: marketer.latitude,
  lng: marketer.longitude,
  distance: marketer.distance,
  status: marketer.status,
  role: marketer.role,
  online_status: marketer.onlineStatus,
  last_location_update: marketer.lastLocationUpdate.toISOString(),
  created_at: marketer.createdAt?.toISOString(),
  updated_at: marketer.updatedAt?.toISOString()
});
